import { toHm, toISO } from '@/common/utils/Dates';
import { getImagePath } from '@/common/constants/ConstCode';
import { timezoneDate } from '@/common/utils/DateManager';

export const renderName = (name, locale) =>
  `${name}${locale === 'ko' ? 'Kr' : 'Vn'}`;

const findProfileByBubbleUser = ({ profiles = [], lastBubble = {} }) => {
  const userNo = lastBubble?.userNo ?? '';
  return profiles.find((elem) => elem.userNo === userNo) ?? {};
};

export const renderNameTag = ({ profiles = [], lastBubble = {} }) => {
  const selected = findProfileByBubbleUser({ profiles, lastBubble });
  return selected?.name ?? ' ';
};

export const renderCounterpartName = ({ profiles = [] }, currentUserNo = '') =>
  (profiles.filter((elem) => elem.userNo !== currentUserNo)?.pop() ?? {}).name ?? '-';

export const renderProfileImage = ({ profiles = [], lastBubble = {} }) => {
  const selected = findProfileByBubbleUser({ profiles, lastBubble });

  return selected?.profile?.storedFileName
    ? getImagePath(selected.profile.storedFileName)
    : require('@/assets/static/images/i_user_on.svg');
};
export const renderRegDate = (regDate) => {
  if (!regDate) return '';

  const reg = new Date(regDate).getTime();
  const now = timezoneDate().getTime();
  if (now - reg > 1000 * 60 * 60 * 24) return toISO(regDate);
  else return toHm(regDate);
};

export const renderContent = (lastBubble, t) => {
  const type = lastBubble?.type;
  if (type && type === 'PLAIN') return lastBubble?.content ?? '';
  else if (type && type === 'IMAGE') return t('common.chat_image');
  else return ' ';
};

export const scrollDown = (target) => {
  const timeout = setTimeout(() => {
    const bottom = document.getElementById(target)?.scrollHeight ?? 0;
    document.getElementById(target)?.scrollTo({ top: bottom });
    clearTimeout(timeout);
  }, 500);
};
